import { c as _c } from "react/compiler-runtime";
import { Stack, StackProps } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export const CalloutStack: React.FC<{
  children?: any;
  stackProps?: StackProps;
}> = props => {
  const $ = _c(12);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue(["stretch", "stretch", "center"]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue(["column", "column", "row"]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== getBreakpointValue) {
    t2 = getBreakpointValue(["stretch", "stretch", "space-between"]);
    $[4] = getBreakpointValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.children || $[7] !== props.stackProps || $[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t3 = <Stack align={t0} direction={t1} gap={4} justify={t2} {...props.stackProps}>{props.children}</Stack>;
    $[6] = props.children;
    $[7] = props.stackProps;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};